'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickyFill = require('react-sticky-fill');

var _reactStickyFill2 = _interopRequireDefault(_reactStickyFill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onServer = process.env.REACT_APP_SERVER;

function Sticky(props) {
  if (onServer) {
    return _react2.default.createElement(
      'div',
      { className: props.className },
      props.children
    );
  }

  return _react2.default.createElement(_reactStickyFill2.default, props);
}

Sticky.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};
Sticky.defaultProps = {
  className: undefined,
  children: null
};

exports.default = Sticky;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/Sticky.js
// module id = 1173
// module chunks = 0